import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Link } from "react-router-dom";

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/mine").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  const statusLabel = (o) => {
    if (o.payment_status === "paid" && o.shipping_status === "shipped") return { t: "Expédié", c: "bg-green-500/20 text-green-400" };
    if (o.payment_status === "paid") return { t: "Payé — en préparation", c: "bg-[#FF3B00]/20 text-[#FF3B00]" };
    if (o.payment_status === "refunded") return { t: "Remboursé", c: "bg-white/20" };
    return { t: "En attente", c: "bg-white/10 text-white/50" };
  };

  return (
    <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-10" data-testid="orders-page">
      <h1 className="font-display text-6xl md:text-8xl uppercase border-b border-white/10 pb-6 mb-8">Mes commandes</h1>
      {loading ? <div className="text-white/50 uppercase tracking-widest">Chargement...</div> :
        orders.length === 0 ? (
          <div className="border border-white/10 p-16 text-center text-white/50">
            Aucune commande. <Link to="/catalogue" className="text-[#FF3B00] underline">Explorer</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => {
              const s = statusLabel(o);
              return (
                <div key={o.id} className="border border-white/10 p-6" data-testid={`order-${o.id}`}>
                  <div className="flex items-baseline justify-between flex-wrap gap-2">
                    <div>
                      <div className="text-xs uppercase tracking-widest text-white/40">Commande #{o.id.slice(-8).toUpperCase()}</div>
                      <div className="text-sm text-white/60 mt-1">{new Date(o.created_at).toLocaleString("fr-FR")}</div>
                    </div>
                    <div className={`px-3 py-1 text-xs uppercase tracking-widest ${s.c}`}>{s.t}</div>
                  </div>
                  <div className="mt-4 space-y-2">
                    {o.items.map((it, i) => (
                      <div key={i} className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-[#111]">
                          {it.image && <img src={fileUrl(it.image)} className="w-full h-full object-cover" alt="" />}
                        </div>
                        <div className="flex-1">
                          <div className="text-xs uppercase tracking-widest text-white/40">{it.artist_name}</div>
                          <div className="font-medium">{it.name} × {it.quantity}</div>
                        </div>
                        <div className="font-display text-xl">${(it.price * it.quantity).toFixed(2)}</div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4 pt-4 border-t border-white/10 flex justify-between font-display text-2xl">
                    <span>Total</span><span>${o.subtotal.toFixed(2)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )
      }
    </div>
  );
}
